<template>
<div class="airlinemediaform">
  <div class="airlinemediaform__loading" v-if="isLoading">
  </div>
  <div class="airlinemediaform__header" v-else>
    <h1 v-if="isEdit" class="medium-title">Edit Media</h1>
    <h1 v-else class="medium-title">Add New Media</h1>
  </div>
  <div class="airlinemediaform__body" v-if="!isLoadingPage">
    <div class="airlinemediaform__body__left">
      <div class="airlinemediaform__body__left__container">
        <h1 class="subhead title">Media Information</h1>
        <div class="airlinemediaform__body__left__container__item">
          <adx-input :label="`Name`" :value.sync="model.name" :inputId="`name`"
            :error.sync="vuelidateOptions.name.error" :ref="vuelidateOptions.name.ref"/>
        </div>
        <div class="airlinemediaform__body__left__container__item">
          <adx-select-dropdown :label="`Categories`" :options="categoryOptions" :value.sync="model.category" :loading="isLoadingForm"
            :error.sync="vuelidateOptions.category.error" :ref="vuelidateOptions.category.ref" @selected="selectedCategory"/>
          <adx-select-dropdown :label="`Media Type`" :options="mediaTypeOption" :value.sync="model.mediaType" :loading="isLoadingForm"
            :error.sync="vuelidateOptions.mediaType.error" :ref="vuelidateOptions.mediaType.ref"/>
          <adx-single-search-dropdown :label="`Brands`" :optionsParam="brandOptions" :value.sync="model.brand" :loading="isLoadingForm"
              :size="'size'" :ref="vuelidateOptions.brand.ref" :error.sync="vuelidateOptions.brand.error"
              :insertAddNew="`true`" @addNew="toggleBrandModal"/>
        </div>
        <div class="airlinemediaform__body__left__container__item">
          <adx-textarea :label="`Description`" :value.sync="model.description" 
            :error.sync="vuelidateOptions.description.error" :ref="vuelidateOptions.description.ref"/>
        </div>
      </div>
      <!--- for airport --->
      <div class="airlinemediaform__body__left__container" v-if="isAirport">
        <h1 class="subhead title">Location Detail (Optional)</h1>
         <div class="airlinemediaform__body__left__container__item">
          <adx-textarea :label="`Address`" :value.sync="modelAirport.locationDescription" 
            :error.sync="vuelidateAirport.locationDescription.error" :ref="vuelidateAirport.locationDescription.ref"/>
        </div>
        <div class="airlinemediaform__body__left__container__item">
          <adx-single-search-dropdown :label="`Province`" :optionsParam="provinceOptions" :value.sync="modelAirport.province" :loading="isLoadingForm"
            :size="'size'" :ref="vuelidateAirport.province.ref" :error.sync="vuelidateAirport.province.error"/>
          <adx-single-search-dropdown :label="`City`" :optionsParam="cityOptions" :value.sync="modelAirport.city" :loading="isLoadingForm"
            :size="'size'" :ref="vuelidateAirport.city.ref" :error.sync="vuelidateAirport.city.error"/>
        </div>
        <div class="airlinemediaform__body__left__container__item">
          <adx-single-search-dropdown :label="`Area`" :optionsParam="areaOptions" :value.sync="modelAirport.area" :loading="isLoadingForm"
            :size="'size'" :ref="vuelidateAirport.area.ref" :error.sync="vuelidateAirport.area.error"/>
          <adx-input :label="`Zip Code`" :value.sync="modelAirport.zipcode" :isNumberOnly="true" :inputId="`zipcode`"
            :error.sync="vuelidateAirport.zipcode.error" :ref="vuelidateAirport.zipcode.ref"/>
        </div>
      </div>
      <div class="airlinemediaform__body__left__container" v-if="isAirport">
        <h1 class="subhead title">Operating Hours (Optional)</h1>
        <div class="airlinemediaform__body__left__container__item operatingHours">
          <div class="operatingHourWrapper" v-for="(day, index) in 7" :key="index">
            <div class="checkbox-wrapper"><adx-checkbox v-if="modelAirport.operatingHours[index]" :inputId="index+'_open'" :label="daysOfWeek[index]" 
            :value.sync="modelAirport.operatingHours[index].isOpen" @buttonClicked="selectedDayOpen(index)" :key="reRenderDay[index]"/></div>
            <div class="opening-closing-wrapper">
            <div :class="[vuelidateAirport.operatingHours.error[index] ? ((vuelidateAirport.operatingHours.error[index].start) || (vuelidateAirport.operatingHours.error[index].end ) ? 'daily-hours warning' : 'daily-hours') : 'daily-hours']"
             :ref="vuelidateAirport.operatingHours.ref.start" :error.sync="vuelidateAirport.operatingHours.error[index].start" :key="reRenderHour[index]">
              <div class="hour-wrapper start" :ref="vuelidateAirport.operatingHours.ref.end" :error.sync="vuelidateAirport.operatingHours.error[index].end">
                <span class="mini-font color-grey"> Opening Hours </span>
                <adx-dropdown-list v-if="modelAirport.operatingHours[index]" :list="operatingHourOptions" @selected="selectedStart($event, index)" :loading="isLoadingForm"
                :labelButton="modelAirport.operatingHours[index].startLabel?modelAirport.operatingHours[index].startLabel:'Unset'"  /></div>
              <div class="arrow">
                <i class="icon-arrow-forward"></i>
              </div>
              <div class="hour-wrapper end">
                <span class="mini-font color-grey"> Closing Hours </span>
                <adx-dropdown-list v-if="modelAirport.operatingHours[index]" :list="operatingHourOptions" @selected="selectedEnd($event, index)" :loading="isLoadingForm"
                :labelButton="modelAirport.operatingHours[index].endLabel? modelAirport.operatingHours[index].endLabel:'Unset'"/></div>
            </div>
            <div v-if="vuelidateAirport.operatingHours.error[index] ? (vuelidateAirport.operatingHours.error[index].start || vuelidateAirport.operatingHours.error[index].end) : false"
                class="error-message small-font color-red"
              >{{vuelidateAirport.operatingHours.error[index].start || vuelidateAirport.operatingHours.error[index].end}}</div>
            </div>
            <div class="checkbox-wrapper">
              <adx-checkbox v-if="modelAirport.operatingHours[index]" :label="`24 Hours`" :inputId="index+'_24h'" 
                :value.sync="modelAirport.operatingHours[index].is24Hours" @buttonClicked="selected24Hours(index)"/>
            </div>
          </div>
        </div>
      </div>
      <!--- for inflight --->
      <div class="airlinemediaform__body__left__container" v-if="!isAirport">
        <h1 class="subhead title">Aircraft & Estimated Flight Route (Optional)</h1>
        <div class="airlinemediaform__body__left__container__item">
          <adx-input :label="`Number of Aircrafts`" :value.sync="modelInflight.numberAircraftInput"
            :error.sync="vuelidateInflight.numberAircraftInput.error" :ref="vuelidateInflight.numberAircraftInput.ref" />
        </div>
        <div class="airlinemediaform__body__left__container__item"  v-for="(route, index) in modelInflight.flightRoutes" :key="index">
          <adx-select-dropdown :label="`Region`" :options="flightRegionOptions" :value.sync="route.region" :loading="isLoadingForm"
            :error.sync="vuelidateInflight.flightRoutes.error[index].region" :ref="vuelidateInflight.flightRoutes.ref.region"
            :insertAddNew="`true`" @addNew="toggleRegionModal(index)"/>
          <adx-input :label="`City of Airport`" :value.sync="route.cityOfAirport"
            :error.sync="vuelidateInflight.flightRoutes.error[index].cityOfAirport" :ref="vuelidateInflight.flightRoutes.ref.cityOfAirport" />
          <div class="icon-wrapper"> <i @click="deleteRoute(modelInflight.flightRoutes, index)" class="icon-deleted color-grey"></i> </div>
        </div>
        <div class="line-wrapper">
          <hr class="line" />
        </div>
        <div class="addNewButton">
          <button @click="addRoute" class="color-red">Add new</button>
        </div>
      </div>
      <div class="airlinemediaform__body__left__container">
        <h1 class="subhead title">Content Restriction</h1>
        <div class="airlinemediaform__body__left__container__item tags">
          <adx-input-tag v-if="model.termAndCondition" :limit="tagLimit" :label="`Terms & condition ( use comma to separated )`" :value="model.termAndCondition" v-model="model.termAndCondition"
              :add-tag-on-blur="model.addTagOnBlur"/>
        </div>
        <div class="airlinemediaform__body__left__container__item tags">
          <adx-input-tag :limit="tagLimit" :label="`File Requirement ( use comma to separated )`" :value="model.fileRequirement" v-model="model.fileRequirement"/>
        </div>
      </div>
      <div class="airlinemediaform__body__left__container">
        <h1 class="subhead title">Images (Optional)</h1>
        <div v-for="(image, index) in model.images" :key="index" class="airlinemediaform__body__left__container__images" >
          <div class="airlinemediaform__body__left__container__images__image">
            <div class="upload-wrapper">
              <div class="top">
                <div v-if="image.imageUrl" class="file-image">
                  <img :src="image.imageUrl" />
                </div>
                <!-- <adx-progress-bar /> -->
                <div class="file-name">
                  <span class="image_name">
                    <label>{{image.caption}}</label>
                    <!-- <i v-if="image.caption" @click="cancelImage(index)" class="adx-ic_cancel"></i> -->
                  </span>
                </div>
              </div>
              <div class="bottom">
                <div>
                  <adx-checkbox :label="`Set as featured image`" :valueLabel.sync="image.isFeatured" :value.sync="image.isFeatured"
                    :inputId="index" @buttonClicked="setFeaturedImage(image)"/>
                </div>
                <div class="icon-wrapper">
                  <i @click="deleteImages(model.images, index)" class="icon-deleted"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-for="(image, index) in model.imagesNew" :key="index+'_new'" class="airlinemediaform__body__left__container__images" >
          <div class="airlinemediaform__body__left__container__images__image">
            <div class="upload-wrapper">
              <div class="top">
                <div v-if="image.imageUrl" class="file-image">
                  <img :src="image.imageUrl" />
                </div>
                <!-- <adx-progress-bar /> -->
                <div class="file-name">
                  <span class="image_name">
                    <label>{{image.caption}}</label>
                    <!-- <i v-if="image.caption" @click="cancelImage(index)" class="adx-ic_cancel"></i> -->
                  </span>
                  <div class="image_status" v-if="imageLoadings[index] != null">
                    <span class="is_loading" v-if="imageLoadings[index]">Loading...</span>
                    <span class="is_success" v-if="!imageLoadings[index] && image.isSuccess">Uploaded</span>
                    <span class="is_error" v-if="!imageLoadings[index] && !image.isSuccess">Error</span>
                  </div>
                </div>
              </div>
              <div class="bottom">
                <div>
                  <adx-checkbox :label="`Set as featured image`" :valueLabel.sync="image.isFeatured" :value.sync="image.isFeatured"
                    :inputId="index+'_new'" @buttonClicked="setFeaturedImage(image)"/>
                </div>
                <div class="icon-wrapper">
                  <i @click="deleteImages(model.imagesNew, index)" class="icon-deleted"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="airlinemediaform__body__left__container__item upload">
            <input type="file" accept=".jpg, .jpeg, .png" @change="getFileImage($event)"
              :ref="`fileUpload`" style="display: none;">
            <div class="browse" @click="launchFilePicker">
              <span class="title">Browse file to upload</span>
              <span class="description">Allowed file type jpg and png. Maximum size 300Kb</span>
            </div>
        </div>
      </div>
      <div class="airlinemediaform__body__left__placement">
      <div class="airlinemediaform__body__left__placement__items">
        <table>
          <thead class="none">
            <tr>
              <td class="header subhead">PLACEMENT</td>
              <td class="header subhead center-title">BOTTOM PRICE</td>
              <td class="header subhead center-title">PUBLIC PRICE</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in model.placements" :key="index" class="content">
              <td class="placement subhead">{{item.name}}</td>
              <td class="check-icon subhead">{{item.bottomPrice | formatMoney}}</td>
              <td class="check-icon subhead">{{item.publicPrice | formatMoney}}</td>
            </tr>
          </tbody>
        </table>
        <div class="emptyState" v-if="model.placements.length < 1">
          <adx-empty-selection />
        </div>
      </div>
    </div>
    </div>
    <div class="airlinemediaform__body__right">
      <div class="airlinemediaform__body__right__container">
        <h1 class="subhead title">Ownership</h1>
        <div class="airlinemediaform__body__left__container__item">
          <adx-single-search-dropdown :label="`Owner`" :optionsParam="ownerOptions" :value.sync="model.owner" :loading="isLoadingForm"
              :size="'size'" :ref="vuelidateOptions.owner.ref" :error.sync="vuelidateOptions.owner.error"/>
        </div>
      </div>
      <!-- note: temporary removed -->
      <!-- <div class="airlinemediaform__body__right__container">
        <h1 class="subhead title">Profiling (Optional) </h1>
        <div class="airlinemediaform__body__left__container__item">
          <adx-single-search-dropdown :label="`Profile`" :optionsParam="profileOptions" :value.sync="model.selectedProfile" :loading="isLoadingForm"
              :size="'size'"  :insertAddNew="`true`" @addNew="addProfiling"/>
        </div>
      </div> -->
      <div class="button"><button class="btn-regular primary" @click="validateMedia" :disabled="saveLoading">Save  <adx-loading-2 v-if="saveLoading" /></button></div>
    </div>
  </div>
  <adx-loading v-else/>

  <!-- Modal -->
  <adx-modal
    v-if="isShowBrandModal"
    @modal-close="toggleBrandModal"
    title="Add New Brand"
    type="small">
    <div slot="content" class="airlinemediaform__modal">
      <div class="airlinemediaform__modal__top">
        <adx-input :value.sync="modelInputBrand.brandInput" label="Brand" :validation="['NewNotEmpty', 'NewMaxLength:50', 'NewMinLength:3', 'Alphanumeric']"
          :ref="vuelidateModal.brandInput.ref" :error.sync="vuelidateModal.brandInput.error" @keypress.enter.native="validateBrand" />
      </div>
      <div class="airlinemediaform__modal__bottom">
        <button class="btn-regular secondary" @click="toggleBrandModal">Cancel</button>
        <button class="btn-regular primary save" :disabled="modalLoading"  @click="validateBrand">
          Save
          <adx-loading-2 v-if="modalLoading" />
        </button>
      </div>
    </div>
  </adx-modal>
  <adx-modal
    v-if="isShowRegionModal"
    @modal-close="toggleRegionModal"
    title="Add New Region"
    type="small">
    <div slot="content" class="airlinemediaform__modal">
      <div class="airlinemediaform__modal__top">
        <adx-input :value.sync="modelInputRegion.regionInput" label="Region" :validation="['NewNotEmpty', 'NewMaxLength:50', 'NewMinLength:3']"
          :ref="vuelidateModalRegion.regionInput.ref" :error.sync="vuelidateModalRegion.regionInput.error" @keypress.enter.native="validateRegion" />
      </div>
      <div class="airlinemediaform__modal__bottom">
        <button class="btn-regular secondary" @click="toggleRegionModal">Cancel</button>
        <button class="btn-regular primary save" :disabled="modalLoading" @click="validateRegion">
          Save
          <adx-loading-2 v-if="modalLoading" />
        </button>
      </div>
    </div>
  </adx-modal>
</div>
</template>


<script>
import types from '@/lib/types'
import api from "@/api"
import InputTag from "@/components/Form/InputTag";
import { required, minLength, maxLength, numeric, alphaNum, alpha, requiredIf } from 'vuelidate/lib/validators'
import { ACheckbox, AInput, ATextArea, ASelectDropdown, AModal, ALoadingSecondary, AListDropdown,
        ALoadingSecondaryWhite, ASingleSearchDropdown, ALoadingPrimary, AEmptySelection} from "ui-kit-v1"

import { sizeConverter } from '@/lib/util'
import { globalMixins } from "@/lib/mixins/globalMixins";
import { restEdge } from "@/api/edgeUrls"
import { mapListFilter } from '@/lib/transformer'

import * as validationLib from "@/lib/validation/"
const { helpers, validate } = validationLib;

export default {
  name: 'adx-airline-media-form',
  components: {
    "adx-checkbox": ACheckbox,
    "adx-input": AInput,
    "adx-input-tag": InputTag,
    "adx-select-dropdown": ASelectDropdown,
    "adx-textarea": ATextArea,
    "adx-dropdown-list": AListDropdown,
    "adx-modal": AModal,
    "adx-empty-selection": AEmptySelection,
    "adx-loading-secondary": ALoadingSecondary,
    "adx-loading-2": ALoadingSecondary,
    "adx-loading": ALoadingPrimary,
    "adx-single-search-dropdown": ASingleSearchDropdown,
  },
  mixins: [globalMixins],
  props: {},
  data() {
    return {
      airportCategoryName: 'airport advertising',
      daysOfWeek: types.days_of_week,
      deletedRouteIds: [],
      id: null,
      imageLoadings: [],
      indexRegion: null,
      isLoading: false,
      isLoadingForm: false,
      isLoadingPage: false,
      isShowBrandModal: false,
      isShowRegionModal: false,
      locationId: 0,
      modalLoading: false,
      openingHoursMonday:null,
      reRenderDay: [0,0,0,0,0,0,0],
      reRenderHour: [0,0,0,0,0,0,0],
      saveLoading: false,
      selectedCategoryLabel: 'airport advertising',
      selectedProfile: 0,
      tagLimit: 100,
      model: {
        brand: null,
        category: 1,
        mediaType: null,
        description: null,
        fileRequirement: [],
        images: [],
        imagesNew: [],
        name: null,
        termAndCondition: [],
        owner: null,
        placements: [],
      },
      modelInputBrand: {
        brandInput: null
      },
      modelInputRegion: {
        regionInput: null
      },
      modelInflight: {
        numberAircraftInput: null,
        flightRoutes: [
          {
            region: null,
            cityOfAirport: null,
          }
        ],
      },
      modelAirport: {
        locationDescription: null,
        province: null,
        area: null,
        city: null,
        zipcode: null,
        operatingHours: [ {
          value: null,
          start: null,
          end:null,
          is24Hours:null,
          isOpen:null
        }]
      },
      vuelidateModal: {
        brandInput: {
          field: 'brand',
          error: null,
          ref: 'brandInput'
        }
      },
      vuelidateModalRegion: {
        regionInput: {
          field: 'region',
          error: null,
          ref: 'regionInput'
        }
      },
      vuelidateInflight: {
        numberAircraftInput: {
          field: 'number of aircraft',
          error: null,
          ref: 'numberAircraftInput'
        },
        flightRoutes: {
          field: {
            region: 'region',
            cityOfAirport: 'city of airport'
          },
          error: [
            {
              region: null,
              cityOfAirport: null
            }
          ],
          ref: {
            region: 'region',
            cityOfAirport: 'cityOfAirport'
          },
        },
      },
      vuelidateAirport: {
        locationDescription: {
          field: 'address',
          error: null,
          ref: 'locationDescription'
        },
        province: {
          error: null,
          ref: 'province'
        },
        area: {
          error: null,
          ref: 'area'
        },
        city: {
          error: null,
          ref: 'city'
        },
        zipcode: {
          error: null,
          zipcode: 'zipcode'
        },
        operatingHours: {
          field: {
            start: 'opening hour',
            end: 'closing hour',
          },
          error: [
            {
              start: null,
              end: null,
            },
            {
              start: null,
              end: null,
            },
            {
              start: null,
              end: null,
            },
            {
              start: null,
              end: null,
            },
            {
              start: null,
              end: null,
            },
            {
              start: null,
              end: null,
            },
            {
              start: null,
              end: null,
            }
          ],
          ref: {
            start: 'start',
            end: 'end',
          },
        },
      },
      vuelidateOptions: {
        name: {
          error: null,
          ref: 'name'
        },
        brand: {
          error: null,
          ref: 'brand'
        },
        category: {
          error: null,
          ref: 'category'
        },
        mediaType: {
          field: 'media type',
          error: null,
          ref: 'mediaType'
        },
        description: {
          error: null,
          ref: 'description'
        },
        owner: {
          error: null,
          ref: 'owner'
        },
      },
      categoryOptions: [],
      brandOptions: [],
      flightRegionOptions: [],
      cityOptions: [],
      profileOptions: [],
      provinceOptions: [],
      mediaTypeOption: [],
      areaOptions: [],
      ownerOptions: [],
      operatingHourOptions:[],
      getStyle: (() => {
        if (this.formStyle === `block`) {
          return {
            group: `flex-direction: column;`,
            child: `margin: 8px 0;`
          }
        }
        return {}
      })()
    }
  },
  validations: {
    model: {
      name: { required, minLength: minLength(3), maxLength: maxLength(50) },
      category: { required },
      brand: { required },
      description: { required, minLength: minLength(3) }, 
      owner: { required },
      mediaType: { required }
    },
    modelInputBrand: {
      brandInput: { required, minLength: minLength(3), maxLength: maxLength(50) },
    },
    modelInputRegion: {
      regionInput: { required, minLength: minLength(3), maxLength: maxLength(50) }
    },
    modelInflight: { //note: sementara optional jd tidak perlu validasi
      // numberAircraftInput: { required, numeric },
      flightRoutes: {
        $each: {
          region: { 
            requiredIf: requiredIf((obj) => obj.cityOfAirport != null)
          },
          cityOfAirport: {
            requiredIf: requiredIf((obj) => obj.region != null)
          }
        }
      }
    },
    modelAirport: {
      // locationDescription: { required, minLength: minLength(3) },
      // province: { required },
      // area: { required },
      // city: { required },
      // zipcode: { required, minLength: minLength(3), numeric},
      operatingHours: {
        $each: {
          start: { 
            requiredIf: requiredIf((obj) => obj.end != null)
          },
          end: {
            requiredIf: requiredIf((obj) => obj.start)
          }
        }
      },
    }
  },
  computed: {
    isEdit: function(){
      this.id = this.$route.params.id
      return this.$route.params.id
    },
    isAirport: function(){
      return this.selectedCategoryLabel === this.airportCategoryName
      // return this.model.category == 2
    },
  },
  watch: {

  },
  beforeCreate() {

  },
  created() {
    
  },
  async beforeMount() {
    this.isLoading = true
    this.isLoadingPage = true
    this.getHours()
    this.getOperatingHours()
    await this.getFormOptions()

    if(this.isEdit){
      this.getMedia()
    } else {
      this.isLoadingPage = false
    }
  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    async getFormOptions(){
      this.isLoadingForm = true
      const response = await api.get(restEdge.airlineMediaFilter, { needToken: true, useRestEdge: true });

      if (response.status == 200) {
        this.brandOptions = mapListFilter({obj: response.data.brand, id:`id`, value:`id`, label: `title`})
        this.areaOptions = mapListFilter({obj: response.data.area, id:`id`, value:`id`, label:`name`})
        this.categoryOptions = mapListFilter({obj: response.data.category, id:`id`, value: `id`, label:`title`})
        this.cityOptions = mapListFilter({obj: response.data.city, id:`id`, value:`id`,label:`name`})
        this.ownerOptions = mapListFilter({obj: response.data.owner, id:`id`, value:`id`, label: `email`})
        this.provinceOptions = mapListFilter({obj: response.data.province, id:`id`, value: `id`, label: `name`})
        this.flightRegionOptions =  mapListFilter({obj: response.data.region, id: `id`, value: `id`, label: `name`})
        this.profileOptions = mapListFilter({obj: response.data.profile, id:`id`, value: `id`, label: `title`})
        this.mediaTypeOption = mapListFilter({obj: response.data.mediaType, id: `id`, value: `id`, label: `name`})
      }
      this.isLoadingForm = false
    },
    getHours() {
      let file = `/static/data/hours.json`;
      (async () => {
        let request = await fetch(new Request(file));
        let data = await request.json();

        data.hours.map(hour => { this.operatingHourOptions.push({ 'id': hour.id, 'label': hour.label, 'value': hour.id })})        
      })();
    },
    async getOperatingHours(){
      let arr = [...Array(7).keys()].map((el) => {
        return { value: el, start: null, end:null, startLabel: null, endLabel:null, is24Hours:false, isOpen:null }
      })
      
      this.modelAirport.operatingHours = await arr
      this.isLoading = false
    },
    async getMedia(){
      const {data, status} = await api.get(restEdge.adminAirlineGetMedia(this.id), { needToken: true, useRestEdge: true });
      if (status == 200) {
        this.mapData(data)
      }
    },
    mapData(data){

      this.model.description = data.description
      this.model.fileRequirement = data.fileRequirement
      this.model.name = data.name
      this.model.termAndCondition = data.termsCondition
      this.model.placements = data.airlinesPlacement
      this.model.images = data.airlinesContent.map(x => {
        return {
          imageUrl: x.imageUrl,
          caption: x.caption,
          isFeatured: x.isFeatured,
        }
      })
      this.model.brand = data.brandId
      this.model.category = data.airlinesCategoryId
      this.model.mediaType = data.airlinesMediaTypeId
      this.model.owner = data.owner ? data.owner.id : null
      this.model.selectedProfile = data.profile? data.profile.id : null

      let category = this.categoryOptions.filter(x => {
        return x.id == this.model.category
      }).pop()
      this.selectedCategoryLabel = category? category.label.toLowerCase(): '' 

      if (this.selectedCategoryLabel ===  this.airportCategoryName) {//Airport 
        if (data.location) {
          this.locationId = data.location.id
          this.modelAirport.locationDescription = data.location.address
          this.modelAirport.province = data.location.provinceId
          this.modelAirport.area = data.location.areaId
          this.modelAirport.city = data.location.cityId
          this.modelAirport.zipcode = data.location.zipcode
        }

        if (data.operatingHours) {
          // let errors = []
          for(let x of data.operatingHours){
            // if (x.isOpen) {
              let startHour = x.allTime? 0 : x.startHour
              let endHour = x.allTime? 0: x.endHour
              let startLabel = x.startHour? (x.startHour.toString().length > 1?x.startHour + ':00' : '0'+x.startHour +':00'): null
              let endLabel = x.endHour? (x.endHour.toString().length > 1?x.endHour + ':00' : '0'+x.endHour +':00'): null
              if (x.allTime) {
                startLabel = '00:00'
                endLabel = '00:00'
              }
              this.modelAirport.operatingHours[x.dayOfWeek] = {
                // id: x.id,
                value: x.dayOfWeek,
                start: startHour,
                startLabel: startLabel,
                end: endHour,
                endLabel: endLabel,
                is24Hours: x.allTime,
                isOpen: (x.startHour  != null &&  x.endHour != null)
              }
              // errors.push({
              //   start: null,
              //   end: null
              // })
            // }
          }
          // this.vuelidateAirport.operatingHours.error = errors
        }
        
      } else {
        this.modelInflight.numberAircraftInput = data.aircraft
        let routes = []
        let errors = []
        if (data.airlinesEstimatedRoute) {
          for(let x of data.airlinesEstimatedRoute){
            let route = {
              // id: x.id,
              region: x.airlinesRegionId,
              cityOfAirport: x.cityAirport
            }
            routes.push(route)
            errors.push({region: null, cityOfAirport: null})
          }
        }
        
        this.modelInflight.flightRoutes = routes
        this.vuelidateInflight.flightRoutes.error = errors
      }

      this.isLoadingPage = false
    },
    vuelidateHelper(vKey, vuelidateOptions){
      const { key, message, element, collection } = helpers.vuelidateValidationHelper(this.$v[vKey], vuelidateOptions, this.$refs)

      if (collection) {
        vuelidateOptions[key].error[collection.index][collection.collectionKey] = message
      } else {
        vuelidateOptions[key].error = message
      }
      if (typeof element[0] == "undefined") {
        this.$nextTick(function() {
          element.scrollIntoView();
        });
      } else {
        this.$nextTick(function() {
          if (element[0].hasOwnProperty("$el")) {
            element[0].$el.scrollIntoView();
          } else {
            element[0].scrollIntoView();
          }
        });
      }
      this.saveLoading = false
    },
    async validateBrand() {
      this.modalLoading = true;
      this.$v.$touch()
      if (this.$v.modelInputBrand.$invalid) {
        const { key, message, element, collection } = helpers.vuelidateValidationHelper(this.$v.modelInputBrand, this.vuelidateModal, this.$refs)
        this.vuelidateModal[key].error = message
        this.modalLoading = false
      } else {
        
        (async () => {

          let formData = {title: this.modelInputBrand.brandInput}
          const {data, status} = await api.post(restEdge.airlineNewBrand, formData, { needToken: true , useRestEdge: true});

          if (status == 200){
            this.modalLoading = false
            this.toggleBrandModal()
            await this.getFormOptions()
            this.model.brand = data.id
            this.modelInputBrand.brandInput = null
          }
        })();
      }
    },
    async validateRegion() {
      this.modalLoading = true;
      this.$v.$touch()
      if (this.$v.modelInputRegion.$invalid) {
        const { key, message, element, collection } = helpers.vuelidateValidationHelper(this.$v.modelInputRegion, this.vuelidateModalRegion, this.$refs)
        this.vuelidateModalRegion[key].error = message
        this.modalLoading = false
      } else {

        (async () => {

          let formData = {name: this.modelInputRegion.regionInput}
          const {data, status} = await api.post(restEdge.airlineNewRegion, formData, { needToken: true , useRestEdge: true});

          if (status == 200){
            this.modalLoading = false
            
            await this.getFormOptions()
            this.modelInflight.flightRoutes[this.indexRegion].region = data.id
            
            this.toggleRegionModal()
            this.modelInputRegion.regionInput =  null
            // this.model.brand = data.id
          } else {
            this.modalLoading = false
          }
        })();
      }
    },
    validateMedia(){
      this.saveLoading = true
      this.$v.$touch()
      this.nullableErrorOperatingHours()
      if (this.$v.model.$invalid) {
        this.vuelidateHelper('model', this.vuelidateOptions)
        this.saveLoading = false
      } else {
        if (!this.isAirport){
          if (this.$v.modelInflight.$invalid) {
            this.vuelidateHelper('modelInflight', this.vuelidateInflight)
          } else {
            this.saveMedia()
          }
        } else {
          if (this.$v.modelAirport.$invalid) {
            this.vuelidateHelper('modelAirport', this.vuelidateAirport)
          } else {
            this.saveMedia()
          }
        }
      }
    },
    async saveMedia(){
      this.postDeletedRoutes()
      let contents = this.model.images.concat(this.model.imagesNew)
      let contentIds = contents.map((x) => { return x.id })
      let body = {
        brandId: this.model.brand,
        airlinesCategoryId: this.model.category,
        airlinesMediaTypeId: this.model.mediaType,
        description: this.model.description,
        fileRequirement: this.model.fileRequirement,
        name: this.model.name,
        termsCondition: this.model.termAndCondition,
        owner: this.model.owner,
        airlinesContent: contents,
        profileId: this.model.selectedProfile
      }
      let bodyCategory = {}
      if (this.model.category == 1) { //airport
        let opthours = []
        for (let x of this.modelAirport.operatingHours) {
          let opthour = {
            dayOfWeek: x.value,
            startHour: x.isOpen? x.start: null,
            startMinute: 0,
            endHour: x.isOpen? x.end: null,
            endMinute: 0,
            allTime: x.is24Hours,
            // id: x.id,
          }
          opthours.push(opthour)
        }

        bodyCategory = {
          location: {
            cityId: this.modelAirport.city,
            address: this.modelAirport.locationDescription,
            zipcode: this.modelAirport.zipcode,
            provinceId: this.modelAirport.province,
            areaId: this.modelAirport.area,
          },
          operatingHours: opthours,
          category: 'Airport Advertising',
        }
        if (this.isEdit) {
          // bodyCategory.location.id = this.locationId
        }
      } else {
        let routes = []

        for (let x of this.modelInflight.flightRoutes) {
          if (x.region && x.cityOfAirport) {
             let route = {
              // id: x.id,
              airlinesRegionId: x.region,
              cityAirport: x.cityOfAirport
            }
            routes.push(route)
          }
        }

        bodyCategory = {
          aircraft: this.modelInflight.numberAircraftInput,
          estimatedRoutes: routes,
          category: 'Inflight Advertising',
        }
      }

      let form = {...body, ...bodyCategory}
      if (this.isEdit) {
        const response = await api.put(restEdge.adminAirlineEditMedia(this.id), form, {useRestEdge: true, needToken: true});
        this.afterSave(response.status)
        this.saveLoading = false

      } else {
        const response = await api.post(restEdge.adminAirlineCreateMedia, form, {useRestEdge: true, needToken: true});

        this.afterSave(response.status)
        this.saveLoading = false
      }
    },
    afterSave(status) {
      if (status == 200) {
        this.showNotificationAlert("Success", "Media successfully saved!", "success");
        this.$router.push({name: `airlinemedia`})
      } else {
        this.showNotificationAlert("Error", "Oops data can not be saved!", "danger");
      }
    },
    launchFilePicker() {
      this.$refs.fileUpload.click();
    },
    async getFileImage(event) {
      let index = this.model.imagesNew.length
      this.imageLoadings.push(null);
     
      // this.processFiles(event.target.files)
      let input = event.target;
      if (input.files && input.files[0]) {
        let reader = new FileReader();
        let validated_data = this.validateImage(input.files[0]);

        if (!validated_data.is_valid) {
          this.showNotificationAlert("Error", "Image failed to uploaded. Try again!", "danger");
          // image.success = false
        } else {
          // let image = {}
          this.model.imagesNew.push({
            imageUrl: null,
            caption: null,
            name: null,
            image: null,
          })
          let image = this.model.imagesNew[index]
          reader.onload = e => {
            image.imageUrl = e.target.result;
          };
          reader.readAsDataURL(input.files[0]);
          image.caption = input.files[0].name;
          image.image = input.files[0];
          this.processFiles(input.files[0], image, index);
        }
      }
    },
    processFiles(fileData, image, index) {
      if (fileData) {
        let formData = new FormData();
        formData.append("file", fileData);
        formData.append("name", fileData.name);
        formData.append("caption", fileData.name);
        
        (async () => {
          // this.imageLoading = true
          this.$set(this.imageLoadings, index, true);
          const result = await api.post(restEdge.adminAirlineContent, formData, {
            needToken: true,
            useRestEdge: true,
            headers: { 'Content-Type': 'multipart/form-data' }
          });

          await this.$nextTick();
          if(result.status == 200 ) {
            let imageId = result.data.id
            let imageUrl = result.data.imageUrl
            image.id = imageId
            image.imageUrl = imageUrl
            image.image = null
            image.isSuccess = true
          } else {
            this.showNotificationAlert("Error", "Image failed to uploaded. Try again!", "danger");
            image.isSuccess = false
          }
          this.$set(this.imageLoadings, index, false);
        })();

      }
    },
    validateImage(file) {
      let maxSize = 300000; // 300kB
      let data = { is_valid: true }
      if (/image/.test(file.type)) {
        let image_ext_patt = new RegExp(/.jpg|.jpeg|.png/)
        if (!image_ext_patt.test(file.name.toLowerCase())) {
          data.is_valid = false
          data.message = 'Unsupported file type'
          return data
        }
      }
      if (file.size > maxSize) {
        data.is_valid = false
        data.message = `File shouldn't more than ${sizeConverter(maxSize)}`
        return data
      }
      const filename = file.name.split('.')[0]
      if (filename.length > 44) {
        data.is_valid = false
        data.message = 'File name is too long. Maximum size 44 character'
        return data
      }

      return data
    },
    deleteImages(image, index) {
      image.splice(index, 1);
      this.imageLoadings.splice(index, 1);
    },
    addProfiling(){
      this.$router.push({name: 'addnewprofileairline'})
    },
    addRoute(){
      this.modelInflight.flightRoutes.push({ region: null, cityOfAirport: null });
      this.vuelidateInflight.flightRoutes.error.push({ region: null, cityOfAirport: null })
    },
    deleteRoute(route, index) {
      let idRoute = route[index]?route[index].id: null
      this.deletedRouteIds.push(idRoute)
      route.splice(index, 1);
      this.vuelidateInflight.flightRoutes.error.splice(index, 1)
    },
    selectedCategory(params){
      if (params) {
        let value = params.item? params.item.label: ''
        this.selectedCategoryLabel = value.toLowerCase()
      }
    },
    selected24Hours(index){
      let is24HoursVal = this.modelAirport.operatingHours[index].is24Hours
      if (!is24HoursVal) {
        this.modelAirport.operatingHours[index].start = 0
        this.modelAirport.operatingHours[index].end = 0
        this.modelAirport.operatingHours[index].startLabel = '00:00'
        this.modelAirport.operatingHours[index].endLabel = '00:00'
        this.modelAirport.operatingHours[index].isOpen = true
        this.reRenderHour[index] += 1
      }
    },
    selectedDayOpen(index){
      let isOpenVal = this.modelAirport.operatingHours[index].isOpen
      if (isOpenVal) {
        this.modelAirport.operatingHours[index].start = null
        this.modelAirport.operatingHours[index].end = null
        this.modelAirport.operatingHours[index].startLabel = null
        this.modelAirport.operatingHours[index].endLabel = null
        this.modelAirport.operatingHours[index].is24Hours = false
        this.reRenderDay[index] += 1
      }
    },
    async setFeaturedImage(image) {
      await this.model.images.map(async x => {
        if (x.id !== image.id) x.isFeatured = await false;
      });
      await this.model.imagesNew.map(async x => {
        if (x.id !== image.id) x.isFeatured = await false;
      });
    },
    selectedStart(item,index){
      this.modelAirport.operatingHours[index].start = item.value
    },
    selectedEnd(item, index){
      this.modelAirport.operatingHours[index].end = item.value
    },
    toggleBrandModal(){
      this.isShowBrandModal = !this.isShowBrandModal
    },
    toggleRegionModal(index){
      this.indexRegion = index
      this.isShowRegionModal = !this.isShowRegionModal
    },
    async postDeletedRoutes(){
      let idsRoute = this.deletedRouteIds.filter(x=> {return x != null})

      for (let i =  0; i < idsRoute.length; i++){
        try {
           const response = await api.destroy(restEdge.airlineDeleteRoute(idsRoute[i]), { needToken: true, useRestEdge: true,});
        } catch(err){
          console.log('err', err)
        }
       
      }
    },
    nullableErrorOperatingHours(){
      this.vuelidateAirport.operatingHours.error = this.modelAirport.operatingHours.map(oh => {
        return {
          start: null,
          end: null
        }
      })
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>


<style lang='scss'>
.airlinemediaform {
  .selectDropdown .select input {
    min-height: 63px !important;
  }
  .input input {
    min-height: 63px !important;
  }
  .vue-input-tag-wrapper .new-tag {
    margin-top: 0px;
  }

  .input-tag {
    max-height: 24px;
  }
  .teal {
    background-color: unset;
    border: unset;
    color: #262626;
    &:hover {
      background-color: unset;
      border: unset;
    }
  }

  &__body__left__container__item {
    &.operatingHours {
      .operatingHourWrapper {
        .hour-wrapper {
          .dropdown {
            .btn-regular {
              left: -14px;
              border: unset;
              &:hover {
                background-color: unset;
                border: unset;
              }
            }
          }
        }
      }
    }
  }
}
 </style>